import styled from "styled-components";

const FormButton = styled.button`
  font-size: 16px;
  /* CTAs ride the SECONDARY token family (label = -contrast, pressed = -shade)
     — role semantics: secondary = actions/attention (see src/theme/tokens.ts). */
  background-color: var(--app-color-secondary, #fecf48);
  color: var(--app-color-secondary-contrast, #041723);
  padding: 10px;
  display: block;
  cursor: pointer;
  margin: 0px 100px;
  border-radius: 4px;
  text-align: center;
  font-weight: bold;
  box-shadow: 0px 0px 25px -12px #000000;
  border-radius: 30px;
  border: none;
  margin: 0 auto;
  padding: 18px 80px;

  &:active {
    background-color: var(--app-color-secondary-shade, #e0b63f);
  }

  /* 18px/80px padding makes this ~56px tall and 160px wider than its label —
     phone-sized. Trimmed for the laptop range only. */
  @media (min-width: 768px) {
    font-size: 15px;
    padding: 13px 52px;
  }
`;

export default FormButton;